"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = exports.SelectOption = void 0;
var _react = _interopRequireWildcard(require("react"));
var _select = _interopRequireDefault(require("antd/es/select"));
var _classnames = _interopRequireDefault(require("classnames"));
require("antd/es/style/themes/index.less");
require("./style.sass");
var _ChevronIcon = _interopRequireDefault(require("../Icons/components/ChevronIcon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var SelectOption = _select.default.Option; // eslint-disable-next-line react/display-name

exports.SelectOption = SelectOption;
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$getPopupContaine = _ref.getPopupContainer,
    getPopupContainer = _ref$getPopupContaine === void 0 ? function (triggerNode) {
      return triggerNode.parentNode;
    } : _ref$getPopupContaine,
    props = _objectWithoutProperties(_ref, ["getPopupContainer"]);
  return /*#__PURE__*/_react.default.createElement(_select.default, _extends({}, props, {
    ref: ref,
    getPopupContainer: getPopupContainer,
    className: (0, _classnames.default)('sber-select', props.className),
    suffixIcon: props.loading ? props.suffixIcon : _ChevronIcon.default,
    dropdownClassName: (0, _classnames.default)('sber-select-dropdown', props.dropdownClassName, {
      'sber-select-dropdown-lg': props.size === 'large'
    })
  }), props.children);
});
exports.Select = Select;